import React, { Component } from "react";
// core components
import MUIDataTable from "mui-datatables";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchSpeedAlertPeriode, fetchTrackSpeed } from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import CatSpeed from "./catspeed";
import IconSettings from "@material-ui/icons/Settings";
import Grid from "@material-ui/core/Grid";
import _ from "lodash";
import Button from "components/CustomButtons/Button.jsx";
import { NavLink, withRouter } from "react-router-dom";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InactiveCat from "./inactivecat";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardBody from "components/Card/CardBody.jsx";
import FormControl from "@material-ui/core/FormControl";
import { fetchCatSpeed } from "../../api/portal";
import { pushLoader } from "../../actions/main";
import moment from "moment";
import ReactExport from "assets/libs/react-export-excel";
import { TextField } from "@material-ui/core";
import { pushSpeedTarget } from "actions/portal";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const fileName = `Speed Alert ${moment().format("LLL")}`;

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2)
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 300,
    padding: 5
  }
});

let delay = null

class Speed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      selectedCategory: "",
      selectedCategoryPeriode: "30",
      catspeed: [],
      loader: null,
      startDate: moment()
        .subtract(30, "minutes")
        .format("YYYY-MM-DDTHH:mm"),
      endDate: moment().format("YYYY-MM-DDTHH:mm"),
      pageTable: 0,
      totalData: 100,
      searchCheck: null,
      keyword: null,
      sort: ['none', 'none', 'none', 'desc', 'none', 'none', 'none', 'none', 'none', 'none', 'none', ],
      orderby: `"dateCreated"`,
      activeColumn: 3,
      displayStatus: [true, true, false, true, true, true, true, true, true, false, true]
    };
  }

  componentDidMount() {
    if (this.props.speedTarget != []) {
      this.props.pushSpeedTarget([0, 0]);
    }
  }

  UNSAFE_componentWillMount = async () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    await fetchCatSpeed()
      .then(response => {
        const dat = response.data.results;
        this.setState({ catspeed: dat, selectedCategory: dat[0].id });
        // fetchTrackSpeed(dat[0].id, this.state.selectedCategoryPeriode)
        //   .then(response => {
        //     if (response != null) {
        //       this.setState({ datatable: response.data.results });
        //     }
        //   })
        //   .catch(error => {
        //     console.log(error);
        //   });
        // this.props.pushLoader(false);
        // this.setState({ loader: false });
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
    await this.handleSearch(10, 0);
    this.props.pushLoader(false);
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  handlecat = e => {
    this.setState({ selectedCategory: e.target.value });

    fetchTrackSpeed(e.target.value, this.state.selectedCategoryPeriode)
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handlecatperiode = e => {
    this.setState({ selectedCategoryPeriode: e.target.value });
    fetchTrackSpeed(this.state.selectedCategory, e.target.value)
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleStartDate = e => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = e => {
    this.setState({ endDate: e.target.value });
  };
  
  handleKeyword = async(e) => {
    await this.setState({ keyword: e })
    await this.handleSearch(10, 0)
  }

  handleSearchClick = async() => {
    await this.setState({ searchCheck: true, sort: ['none', 'none', 'none', 'desc', 'none', 'none', 'none', 'none', 'none', 'none', 'none', ],
    orderby: `"dateCreated"`, activeColumn: 3 });
    this.handleSearch(10, 0);
  };

  handleSearch = async (row, page) => {
    this.setState({ loader: true, datatable: [] });
    await fetchSpeedAlertPeriode(
      this.state.startDate.replace("T", " "),
      this.state.endDate.replace("T", " "),
      row,
      page * row,
      this.state.orderby,
      this.state.sort[this.state.activeColumn],
      this.state.keyword ? this.state.keyword.toUpperCase() : '',
      this.state.selectedCategory
    )
      .then(response => {
        this.setState({
          datatable: response.data.results,
          totalData: response.data.total
        });
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
    this.setState({ loader: false });
  };

  renderOptcat = e => {
    return <MenuItem value={e.id}> {e.name} </MenuItem>;
  };

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "shipid",
        label: "Ship Id",
        options: {
          filter: false,
          display: this.state.displayStatus[0],
          sortDirection: this.state.sort[0]
        }
      },
      {
        name: "name",
        label: "Ship Name",
        options: {
          filter: false,
          display: this.state.displayStatus[1],
          sortDirection: this.state.sort[1]
        }
      },
      {
        name: "shiptype",
        label: "Shiptype",
        options: {
          filter: false,
          display: this.state.displayStatus[2],
          sortDirection: this.state.sort[2]
        }
      },
      {
        name: "dateCreated",
        label: "DateCreated",
        options: {
          filter: false,
          display: this.state.displayStatus[3],
          sortDirection: this.state.sort[3]
        }
      },
      {
        name: "last_gps",
        label: "Last GPS",
        options: {
          filter: false,
          display: this.state.displayStatus[4],
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          },
          sortDirection: this.state.sort[4]
        }
      },
      {
        name: "last_ais",
        label: "Last AIS",
        options: {
          filter: false,
          display: this.state.displayStatus[5],
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          },
          sortDirection: this.state.sort[5]
        }
      },
      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: this.state.displayStatus[6],
          sortDirection: this.state.sort[6]
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: this.state.displayStatus[7],
          sortDirection: this.state.sort[7]
        }
      },
      {
        name: "catspeedalert",
        label: "Speed Category",
        options: {
          filter: false,
          display: this.state.displayStatus[8],
          sortDirection: this.state.sort[8]
        }
      },
      {
        name: "catspeedalert_id",
        label: "Catspeedalert Id",
        options: {
          filter: false,
          display: this.state.displayStatus[9],
          sortDirection: this.state.sort[9]
        }
      },
      {
        name: "speed",
        label: "Speed Returned in (knots x10)",
        options: {
          filter: false,
          display: this.state.displayStatus[10],
          sortDirection: this.state.sort[10]
        }
      },
      {
        name: "Action",
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <NavLink
                  to={"/portal"}
                  onClick={() => {
                    this.props.pushSpeedTarget([
                      tableMeta.rowData[6],
                      tableMeta.rowData[7]
                    ]);
                  }}
                >
                  <Button size="sm" color="behance" round>
                    View on Map
                  </Button>
                </NavLink>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      filter: false,
      search: true,
      selectableRows: "none",
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,
      textLabels: {
        body: {
          noMatch: this.state.loader
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      },
      onTableChange: async(action, tableState) => {
        switch (action) {
          case "changePage":
            this.handleSearch(tableState.rowsPerPage, tableState.page);
            break;
          case "changeRowsPerPage":
            this.handleSearch(tableState.rowsPerPage, tableState.page);
            break;
          case "propsUpdate":
            if (this.state.searchCheck) {
              this.setState({ searchCheck: false });
              tableState.page = 0;
              tableState.rowsPerPage = 10;
            }
            break;
          case "sort":
            tableState.page = 0;
            const condition = tableState.announceText.split(" ");
            const listColumn = this.state.sort;
            listColumn.forEach((value, index) => {
              let ascdesc;
              if (index === tableState.activeColumn) {
                if (condition[6] === "ascending") {
                  ascdesc = "asc";
                } else {
                  ascdesc = "desc";
                }
                this.state.sort[tableState.activeColumn] = ascdesc;
              } else {
                this.state.sort[index] = "none";
              }
            });
            await this.setState({
              orderby:
                tableState.columns[tableState.activeColumn].name ===
                "dateCreated"
                  ? `"dateCreated"`
                  : tableState.columns[tableState.activeColumn].name,
              activeColumn: tableState.activeColumn,
            });
            this.handleSearch(tableState.rowsPerPage, tableState.page, this.state.activeColumn, this.state.orderby);
            break;
          case "search":
            if (delay !== null) {
              clearTimeout(delay)
            }
            delay = setTimeout(async() => {
              let searchKeyword = tableState.searchText ? tableState.searchText : ''
              await this.handleKeyword(searchKeyword)
              tableState.searchText = this.state.keyword
            }, 3000)
          case "columnViewChange": {
            tableState.columns.forEach((column, index) => {
              if (column.display !== this.state.displayStatus[index]) {
                this.state.displayStatus[index] = column.display
              }
            })
          }
          default:
            break;
        }
      },
      serverSide: true,
      count: this.state.totalData,
      searchText: this.state.keyword
    };

    return (
      <div>
        <Grid item xs={12}>
          <div className={classes.content}>
            <Grid item xs={12}>
              <Button
                color="success"
                round
                onClick={() => this.handleClose("openAdd", true)}
              >
                <IconSettings /> Manage Category
              </Button>
            </Grid>
            <br />
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <FormControl variant="outlined">
                    <Select
                      value={this.state.selectedCategory}
                      onChange={this.handlecat}
                    >
                      {this.state.catspeed.map(this.renderOptcat)}
                    </Select>
                  </FormControl>{" "}
                  {/* <FormControl variant="outlined">
                    <Select
                      value={this.state.selectedCategoryPeriode}
                      onChange={this.handlecatperiode}
                    >
                      <MenuItem value="30"> 30 Minutes </MenuItem>
                      <MenuItem value="60"> 1 Hour </MenuItem>
                      <MenuItem value="240"> 4 Hours </MenuItem>
                      <MenuItem value="1440"> 1 Day </MenuItem>
                    </Select>
                  </FormControl> */}
                  {/* <Grid item xs={12} sm={12} style={{marginRight: 10}}> */}
                  <TextField
                    size="small"
                    id="datetime-local"
                    label="Start Date"
                    type="datetime-local"
                    className={classes.textField}
                    defaultValue={this.state.startDate}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      value: this.state.startDate,
                      onChange: this.handleStartDate
                    }}
                  />
                  <TextField
                    size="small"
                    id="datetime-local"
                    label="End Date"
                    type="datetime-local"
                    className={classes.textField}
                    defaultValue={this.state.endDate}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      value: this.state.endDate,
                      onChange: this.handleEndDate
                    }}
                  />
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={this.state.loader}
                    style={{ marginRight: 20 }}
                    onClick={() => this.handleSearchClick()}
                  >
                    Search
                  </Button>
                  {/* </Grid> */}
                  <ExcelFile
                    element={
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={this.state.loader}
                      >
                        Download as .xslx
                      </Button>
                    }
                    filename={`${fileName}`}
                    fileExtension="xslx"
                  >
                    <ExcelSheet data={this.state.datatable} name="Sheet 1">
                      <ExcelColumn label="Ship ID" value="shipid" />
                      <ExcelColumn label="Ship Name" value="name" />
                      <ExcelColumn label="dateCreated" value="dateCreated" />
                      <ExcelColumn label="last_gps" value="last_gps" />
                      <ExcelColumn label="last_ais" value="last_ais" />
                      <ExcelColumn label="Latitude" value="latitude" />
                      <ExcelColumn label="Longitude" value="longitude" />
                      <ExcelColumn
                        label="Speed Category"
                        value="catspeedalert"
                      />
                      <ExcelColumn
                        label="Speed returned in (knots x10)"
                        value="speed"
                      />
                    </ExcelSheet>
                  </ExcelFile>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <MUIDataTable
                data={this.state.datatable}
                columns={columns}
                options={options}
              />
              <Dialog
                maxWidth={"md"}
                open={this.state.openAdd}
                onClose={() => this.handleClose("openAdd", false)}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">
                  Manage Category
                </DialogTitle>
                <DialogContent>
                  <CatSpeed />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.handleClose("openAdd", false)}
                    color="danger"
                    round
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </div>
        </Grid>
      </div>
    );
  }
}

Speed.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushSpeedTarget: PropTypes.array
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    leftPanel: state.leftPanel,
    speedTarget: state.speedTarget
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushLeftPanel, pushSpeedTarget, pushLoader }
)(withStyles(styles)(Speed)));
